import { MouseEventHandler, ReactNode, useRef, useState } from 'react';

import { Popover } from '@mui/material';

import styled from 'styled-components';

import { TextWrapper } from '../../../TextWrapper';
import { WhichPropertyPopoverContent } from './WhichPropertyPopoverContent';

const StyledWhichProperty = styled.div`
  &.which-property {
    margin-bottom: ${({ theme }) => theme.spacing(3)};
    padding: ${({ theme }) => theme.spacing(0, 2.5)};

    .body {
      margin-top: ${({ theme }) => theme.spacing(1)};
    }

    .popover-text {
      text-decoration: underline;
      cursor: pointer;
    }
  }
`;

export const WhichProperty = () => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const hoverElement = useRef<HTMLSpanElement>(null);

  const handleOnClick: MouseEventHandler<HTMLSpanElement> = (event) => {
    setIsPopoverOpen(true);
    event.stopPropagation();
    event.preventDefault();
  };

  const handleOnClose = () => setIsPopoverOpen(false);

  return (
    <StyledWhichProperty className="which-property">
      <TextWrapper
        formattedMessageProps={{
          id: 'which-property-to-choose',
          defaultMessage: "Don't know which property to choose?",
        }}
        typographyProps={{
          variant: 'h5.semibold',
        }}
      />
      <TextWrapper
        className="body"
        formattedMessageProps={{
          id: 'which-property-content',
          defaultMessage:
            'No need to worry, all Arrived rental properties go through our rigorous selection process and have been pre-vetted for their investment potential by our acquisitions team (<popover>more info</popover>). Rather than focusing on selecting individual properties to invest in, many Arrived investors simply distribute their investment across several available properties to achieve portfolio diversification.',
          values: {
            popover: (chunk: ReactNode) => (
              <span className="popover-text" ref={hoverElement} onClick={handleOnClick}>
                {chunk}
              </span>
            ),
          },
        }}
        typographyProps={{ variant: 'body1' }}
      />
      <Popover
        open={isPopoverOpen}
        anchorEl={hoverElement.current}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        onClose={handleOnClose}
      >
        <WhichPropertyPopoverContent handleOnClose={handleOnClose} />
      </Popover>
    </StyledWhichProperty>
  );
};
